<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Open+Sans:wght@300;400;700&display=swap');

#app {
  font-family: Helvetica, sans-serif;
}

* {
  font-family: 'Inter', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue